export function Paldea(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      {...props}
    >
      {}
      <path
        fill="currentColor"
        d="M17.495 2.182a1 1 0 0 1 .543 1.306c-.495 1.2-1.067 3.905-.409 6.867a5.15 5.15 0 0 1 2.132.152a5.099 5.099 0 1 1 8.341 5.839a5.08 5.08 0 0 1 1.096 3.157a5.09 5.09 0 0 1-1.774 3.866a5.099 5.099 0 1 1-9.255 4.216a5.1 5.1 0 0 1-5.24-4.116q-.09.003-.183.003a5.099 5.099 0 1 1 .923-10.114a5.1 5.1 0 0 1 .753-1.216l-3.79 1.392a5.835 5.835 0 0 1-7.489-3.467L8.62 8.056a5.84 5.84 0 0 1 6.993 2.438c-.665-3.327-.018-6.33.576-7.769a1 1 0 0 1 1.306-.543m-4.253 13.132a3.099 3.099 0 1 0 2.316 4.364a5.1 5.1 0 0 1-2.316-4.364m4.176 5.106a5.12 5.12 0 0 1-2.54 2.586a3.1 3.1 0 1 0 5.158-2.791a5.1 5.1 0 0 1-2.618.205m4.374-1.263a5.08 5.08 0 0 1 1.24 3.256a3.099 3.099 0 0 0 3.546-4.77a5.12 5.12 0 0 1-3.9.443a5 5 0 0 1-.886 1.071m1.585-2.955q.348.083.722.084a3.099 3.099 0 1 0-2.557-4.85a5.09 5.09 0 0 1 1.835 4.766m.722 8.4a5.1 5.1 0 0 1-1.434-.205a5.12 5.12 0 0 1-2.537 2.698a3.1 3.1 0 1 0 5.554-2.744c-.499.163-1.03.25-1.583.25m-8.857-9.197a3.099 3.099 0 1 0 6.197 0a3.099 3.099 0 0 0-6.197 0"
      />
    </svg>
  );
}
